/**
 * BaseStore Abstraction.
 *
 * Common base for all storage classes in the project.
 *
 */

export default class BaseStore {

    // attribute initialization
    public status: boolean;
    public error: string;
    
    public prefix: string = 'fountain';

    /**
     * CookieStore constructor.
     */
    constructor() {
        this.status = true;
        this.error = '';
        this.checkAvailability();
    }

    /**
     * Method stub for testing client storage availability.
     * Should be over-ridden by any inheriting child class.
     */
    public checkAvailability(): void {
        throw new Error('Method not implemented.');
    }

    /**
     * Update status with error content and return false to indicate failure.
     *
     * @param {Error} error
     * @return {boolean}
     */
    protected fail(error: Error) : boolean {
        this.status = false;
        if (typeof(error.toString) === 'undefined') {
            this.error = String(error);
        } else {
            this.error = error.toString();
        }
        // always return false for failure
        return false;
    }

}